// --- components/horseDetails/HorseTraining.jsx ---
import React from 'react';

export default function HorseTraining({ training, temperament, disciplines }) {
  return (
    <div className="mt-5 p-3 font-montserrat shadow">
      <h2 className="text-xl font-bold mb-2">Training & Temperament</h2>
      <div className="flex flex-col">
        <p className="py-2"><strong>Training Level:</strong> {training || 'N/A'}</p>
        <p className="py-2"><strong>Temperament:</strong> {temperament || 'N/A'}</p>
        <p className="py-2"><strong>Disciplines:</strong> {disciplines?.length ? disciplines.join(', ') : 'N/A'}</p>
      </div>
    </div>
  );
}